/**
 * Athlete-related queries
 * Equipment, settings, profile data
 *
 * Mutations live in useAthleteConfigMutations.ts
 */
import { useQuery } from '@tanstack/react-query';
import { useBackend } from './useBackend';
import { createAthleteEquipment } from '../Model/AthleteEquipment/AthleteEquipment';

// Athlete Equipment
export function useAthleteEquipment() {
  const backend = useBackend();

  return useQuery({
    queryKey: ['athlete-equipment'],
    queryFn: async () => {
      const json = await backend.get('/athlete/equipment/current');
      return json ? createAthleteEquipment(json) : createAthleteEquipment();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
